import React, { useEffect, useRef, useState } from 'react'
import { Button, Form, Modal, OverlayTrigger, Popover } from 'react-bootstrap'

import Select from "react-select";
import { lblAddress, lblEmail, lblFirstName, lblLastName, lblPhoneNumber, txtMainInfo, txtSearchAddress } from '../../dataBaseFile/label';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { addressByPlaceId } from '../../service/api/user/addressByPlaceID';
import { searchAddress } from '../../service/api/user/searchAddress';
import InputField from '../../jsx/components/fields/inputField';
import PhonenumberField from '../../jsx/components/fields/phoneFields';
import { enterFirstName, validEmailText, validEmail_OR_MobileNumberText, validFirstName, validMobileNumberText } from "../../dataBaseFile/error";
import { emailValidation, firstNameValidation, minLengthValidation, phoneOnChange, phoneValidation } from '../../functions/validations';
import PrimaryButton from '../../jsx/components/button/primaryButton';
import Avatar from '../../jsx/components/fields/avatar';
import filter from '../../icons/photos/filter.svg';
import { apiGetCompanyById } from '../../service/api/companies/getCompanyById';
import { apiRegisterCompany } from '../../service/api/companies/registerCompany';
import apiUpdateCompany from '../../service/api/companies/updateCompany';
import { setLoaderTime, setUserDetails } from '../../feature/userData/userData';
import ResponceToaster from '../../jsx/components/responceToaster/responceToaster';
import { getCat } from '../../service/api/object/getCat';
import { addCompanyApi } from '../../service/api/companies/addCompany';
import { MdContentCopy } from 'react-icons/md';
import { PiUserSwitchBold } from 'react-icons/pi';
import SwitchRole from '../../jsx/components/switchRole/switchRole';
import EmailPhoneCombine from '../../jsx/components/fields/emailPhoneField';
import { noSpaceOnChange } from '../../validations/validation';
import { shareCompanyCodeApi } from '../../service/api/companies/shareCompanyCode';
import { switchRoleApi } from '../../service/api/user/switchRole';
const UserAddOwnCompany = ({
    companyModalStatus,
    setCompanyModalStatus,
    handleClose,
    modalType,
    companyID,
    firstNameOwner,
    lastNameOwner,
    emailOwner,
    phoneNumberOwner,
    countryCodeOwner,
}) => {

    const { permissionArr, roleArr, roleDisplayName, role } = useSelector((state) => state.user);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const permissionArray = permissionArr[0] || []

    const [addressLine1, setAddressLine1] = useState(" ");
    const [addressLine2, setAddressLine2] = useState(" ");
    const [cityName, setCityName] = useState('')
    const [stateName, setStateName] = useState('')
    const [countryName, setCountryName] = useState(' ')
    const [zipCode, setZipCode] = useState(' ')
    const [latVal, setLatVal] = useState(0)
    const [longVal, setLongVal] = useState(0)
    const [address, setAddress] = useState('')
    const [placeIdVal, setPlaceId] = useState('')
    const [addressArr, setAddressArr] = useState([])
    const [searchText, setSearchText] = useState('')
    const [isCompanytNameError, setIsCompanyNameError] = useState(false)
    const [companyName, setComapanyName] = useState("")
    const [isCompanytEmailError, setIsCompanyEmailError] = useState(false)
    const [companyEmail, setComapanyEmail] = useState(emailOwner ? emailOwner : "")
    const [phonenumber, setPhonenumber] = useState(phoneNumberOwner ? phoneNumberOwner : '');
    const [isPhoneError, setIsPhoneError] = useState(false);
    const [countryCode, setCountryCode] = useState(phoneNumberOwner ? countryCodeOwner : 1);
    const [isEmailError, setIsEmailError] = useState(false);
    const [photoToUpload, setPhotoToUpload] = useState(null)
    const [companyAvatarUrl, setCompanyAvatarUrl] = useState("")
    const [isAddress, setIsAddress] = useState(false)
    const [loaderActive, setLoaderActive] = useState(false)
    const [handleToaster, setHandleToaster] = useState(false);
    const [toasterType, setToasterType] = useState();
    const [resMessage, setResMessage] = useState("");
    const [EIN, setEIN] = useState("")
    const [einErr, setEinErr] = useState(false)

    const [firstName, setFirstName] = useState(firstNameOwner ? firstNameOwner : "");
    const [isFirstNameError, setIsFirstNameError] = useState(false);
    const [lastName, setLastName] = useState(lastNameOwner ? lastNameOwner : "");
    const [errorFirstNameMsg, setErrorFirstNameMsg] = useState("");
    const [expertiseArr, setExpertiseArr] = useState([]);
    const [companyCode, setCompanyCode] = useState('');

    const [shareCompanyCodeModalTrigger, setShareCompanyCodeModalTrigger] = useState(false);
    const [isEmailPhoneVal, setIsEmailPhoneVal] = useState(false);
    const [emailPhoneValue, setEmailPhoneValue] = useState("");
    const [codeValue, setCodeValue] = useState(1);
    const [isPhone, setIsPhone] = useState(false);
    const [shareCompanyCodeLoading, setShareCompanyCodeLoading] = useState(false);

    const copyToClipboard = () => {
        navigator.clipboard.writeText(`${companyCode}`);
        setResMessage("Company code copied to clipboard!");
        setToasterType("success");

        setHandleToaster(true);
        setTimeout(() => {
            setHandleToaster(false);
        }, 4000);
    }

    const formatEINFromResponse = (einNumber) => {
        if (einNumber?.length === 9) {
            return `${einNumber?.slice(0, 2)}-${einNumber?.slice(2, 9)}`;
        }
        return einNumber;
    };

    useEffect(() => {

        if (modalType != "add") {
            let data = {
                company_id_ids: companyID
            }
            dispatch(apiGetCompanyById(data, (res) => {
                res.data.data.ein_chr && setEIN(formatEINFromResponse(res.data.data.ein_chr))
                setComapanyName(res?.data?.data?.company_name_chr)
                setCountryCode(res?.data?.data?.company_phone_code_id_lng)
                setPhonenumber(res?.data?.data?.company_phone_number_int)
                setComapanyEmail(res?.data.data.company_email_chr)
                setPlaceId(res?.data?.data?.place_id_chr)
                setAddressLine1(res?.data?.data?.address_line_1_chr)
                setAddressLine2(res?.data?.data?.address_line_2_chr)
                setCityName(res?.data?.data?.city_name_chr)
                setStateName(res?.data?.data?.state_name_chr)
                setCountryName(res?.data?.data?.country_name_chr)
                setZipCode(res?.data?.data?.zip_code_int)
                setLongVal(res?.data?.data?.longitute_float)
                setLatVal(res?.data?.data?.latitude_float)
                setAddress(res?.data?.data?.company_address_chr)
                setCompanyAvatarUrl(res?.data?.data?.company_logo_url)
                setExpertiseArr(res?.data?.data?.company_expertise)
                setCompanyCode(res?.data?.data?.company_code_chr)
            }, () => { }))
        }
    }, [])
    useEffect(() => {
        const timeOutId = setTimeout(searchCalling, 1000);
        return () => clearTimeout(timeOutId);
    }, [searchText]);

    function searchCalling() {
        if (searchText.trim().length > 2) {

            let details = {
                address_chr: searchText.trim(),
            };
            dispatch(
                searchAddress(details, (res) => { setAddressArr(res.data.data) })
            );
        }
    }

    function handleCompanyNameBlurCheck() {
        if (companyName.length < 2) {
            setIsCompanyNameError(true)
        }
    }
    function handleCompanyName(e) {
        if (modalType == "edit" || modalType == "add") {
            setComapanyName(e.target.value)
            setIsCompanyNameError(false)
        }
    }


    function handleEIN(e) {
        if (modalType == "edit" || modalType == "add") {
            setEinErr(false)
            let einValue = e.target.value.replace(/\D/g, ""); // Remove all non-numeric characters

            // Format EIN as XX-XXXXXXX
            if (einValue.length > 2) {
                einValue = `${einValue.slice(0, 2)}-${einValue.slice(2, 9)}`;
            }
            // setEIN(e.target.value)
            setEIN(einValue)
        }
    }

    const handleOnBlurEIN = () => {
        if (EIN !== '') {
            if (EIN.length !== 10) {
                setEinErr(true)
            }
        }
    }

    function handleCompanyEmailBlurCheck() {
        if (modalType == "edit" || modalType == "add") {
            if (emailValidation(companyEmail)) {
                setIsEmailError(false)
            } else {
                setIsEmailError(true)
            }
        }
    }
    function handleCompanyEmail(e) {
        if (modalType == "edit" || modalType == "add") {
            setComapanyEmail(e.target.value)
            setIsEmailError(false)
        }
        setIsPhoneError(false)
    }

    function handlePhonenumberBlurCheck() {
        if (modalType == "edit" || modalType == "add") {
            if (!phoneValidation(phonenumber) && phonenumber !== '') {
                setIsPhoneError(true);
            }
        }
    }
    const handlePhonenumber = (e) => {
        if (modalType == "edit" || modalType == "add") {
            setIsPhoneError(false);

            phoneOnChange(e.target.value) && setPhonenumber(e.target.value);
        }
        setIsEmailError(false);
    };
    const handleCountryCode = (e) => {
        if (modalType == "edit" || modalType == "add") {
            setCountryCode(e.target.value);
        }
    };

    function handleSubmit() {

        if (modalType == "add") {
            if (!firstNameValidation(firstName)) {
                setIsFirstNameError(true);
                if (firstName === "") {
                    setErrorFirstNameMsg(enterFirstName)
                } else {
                    setErrorFirstNameMsg(validFirstName)
                }
            }

            if (!minLengthValidation(companyName, 3)) {
                setIsCompanyNameError(true)
            }

            if (address == '') {
                setIsAddress(true)
            }
            if (companyEmail.length === 0 && phonenumber.length === 0) {
                // setIsPhoneError(true);
                setIsEmailError(true);
            }

            const einNumber = EIN?.replace(/\D/g, ""); // Remove the hyphen
            if (einNumber !== '') {
                if (einNumber.length !== 9) {
                    setEinErr(true)
                    return;
                }
            }

            if (firstNameValidation(firstName) && minLengthValidation(companyName, 3) && address != '') {
                const addCompany = new FormData();
                addCompany.append("ein_chr", einNumber);
                addCompany.append("company_name_chr", companyName);
                addCompany.append("owner_first_name_chr", firstName);
                addCompany.append("owner_last_name_chr", lastName);
                addCompany.append("company_phone_code_id_int", countryCode || 0);
                addCompany.append("company_phone_number_int", phonenumber || 0);
                addCompany.append("company_email_chr", companyEmail);
                addCompany.append("place_id_chr", placeIdVal);
                addCompany.append("address_line_1_chr", addressLine1);
                addCompany.append("address_line_2_chr", addressLine2);
                addCompany.append("city_name_chr", cityName);
                addCompany.append("state_name_chr", stateName);
                addCompany.append("country_name_chr", countryName);
                addCompany.append("zip_code_int", zipCode);
                addCompany.append("longitude_float", longVal || 0);
                addCompany.append("latitude_float", latVal);
                addCompany.append("company_address_chr", address);
                addCompany.append("creator_id_ids", localStorage.getItem("user_id"));
                photoToUpload != null && addCompany.append("company_logo", photoToUpload, "companyPhoto.png");
                // expertiseArray.length > 0 && addCompany.append("expertise_id_array[]", expertiseArray);
                expertiseArray.length > 0 &&
                    expertiseArray.forEach((item, index) => {
                        addCompany.append("expertise_id_array", item);
                    })


                if (phonenumber.length > 0 && companyEmail.length === 0) {
                    // case 1

                    if (phoneValidation(phonenumber)) {
                        // console.log("All data phone case", firstName, lastName, companyName, companyEmail, phonenumber, countryCode, addressLine1, addressLine2, cityName, stateName, countryName, zipCode, longVal, latVal, address);
                        setLoaderActive(true)
                        dispatch(addCompanyApi(addCompany, (res) => {

                            setToasterType("success");
                            setResMessage(res.data.message);

                            localStorage.setItem("roleId", 4)
                            let data = {
                                role_id_int: localStorage.getItem("roleId")
                            }
                            dispatch(switchRoleApi(data, (res) => {
                                localStorage.setItem("access_token", res.data.access_token)
                                localStorage.setItem("refresh_token", res.data.refresh_token)
                                dispatch(setUserDetails(res.data.data))
                                // navigate("/dashboard")
                                // setToasterType("success");
                                // setHandleToaster(true);

                                // setTimeout(() => {
                                //   setHandleToaster(false);
                                // }, 11000);

                                setLoaderActive(false)
                                handleClose();

                            }, (err) => {
                                setResMessage(err.data.message);
                                setToasterType("success");
                                setHandleToaster(true);
                                setTimeout(() => {
                                    setHandleToaster(false);
                                }, 11000);
                            }))


                            // setHandleToaster(true)
                            // setTimeout(() => {
                            //     setHandleToaster(false);
                            // }, 3000);
                        }, (err) => {
                            setToasterType("error");
                            setHandleToaster(true)
                            setResMessage(err.data.message);
                            setLoaderActive(false)

                            setTimeout(() => {
                                setHandleToaster(false);
                            }, 11000);
                        }))
                    } else {
                        setIsPhoneError(true);
                    }
                }

                if (companyEmail.length > 0 && phonenumber.length === 0) {
                    //case 2

                    if (emailValidation(companyEmail)) {
                        // console.log("All data email case", firstName, lastName, companyName, companyEmail, phonenumber, countryCode, addressLine1, addressLine2, cityName, stateName, countryName, zipCode, longVal, latVal, address);
                        setLoaderActive(true)
                        dispatch(addCompanyApi(addCompany, (res) => {

                            setToasterType("success");
                            setResMessage(res.data.message);

                            localStorage.setItem("roleId", 4)
                            let data = {
                                role_id_int: localStorage.getItem("roleId")
                            }
                            dispatch(switchRoleApi(data, (res) => {
                                localStorage.setItem("access_token", res.data.access_token)
                                localStorage.setItem("refresh_token", res.data.refresh_token)
                                dispatch(setUserDetails(res.data.data))
                                // navigate("/dashboard")
                                // setToasterType("success");
                                // setHandleToaster(true);

                                // setTimeout(() => {
                                //   setHandleToaster(false);
                                // }, 11000);

                                setLoaderActive(false)
                                handleClose();

                            }, (err) => {
                                setResMessage(err.data.message);
                                setToasterType("success");
                                setHandleToaster(true);
                                setTimeout(() => {
                                    setHandleToaster(false);
                                }, 11000);
                            }))

                            // setHandleToaster(true)
                            // setTimeout(() => {
                            //     setHandleToaster(false);
                            // }, 3000);

                        }, (err) => {
                            setToasterType("error");
                            setHandleToaster(true)
                            setResMessage(err.data.message);
                            setLoaderActive(false)

                            setTimeout(() => {
                                setHandleToaster(false);
                            }, 11000);
                        }))
                    } else {
                        setIsEmailError(true);
                    }
                }

                if (companyEmail.length > 0 && phonenumber.length > 0) {
                    // case 3

                    if (emailValidation(companyEmail) && phoneValidation(phonenumber)) {
                        // console.log("All data email phone both case", firstName, lastName, companyName, companyEmail, phonenumber, countryCode, addressLine1, addressLine2, cityName, stateName, countryName, zipCode, longVal, latVal, address);
                        setLoaderActive(true)
                        dispatch(addCompanyApi(addCompany, (res) => {

                            setToasterType("success");
                            setResMessage(res.data.message);

                            localStorage.setItem("roleId", 4)
                            let data = {
                                role_id_int: localStorage.getItem("roleId")
                            }
                            dispatch(switchRoleApi(data, (res) => {
                                localStorage.setItem("access_token", res.data.access_token)
                                localStorage.setItem("refresh_token", res.data.refresh_token)
                                dispatch(setUserDetails(res.data.data))
                                // navigate("/dashboard")
                                // setToasterType("success");
                                // setHandleToaster(true);

                                // setTimeout(() => {
                                //   setHandleToaster(false);
                                // }, 11000);

                                setLoaderActive(false)
                                handleClose();

                            }, (err) => {
                                setResMessage(err.data.message);
                                setToasterType("success");
                                setHandleToaster(true);
                                setTimeout(() => {
                                    setHandleToaster(false);
                                }, 11000);
                            }))


                            // setHandleToaster(true)
                            // setTimeout(() => {
                            //     setHandleToaster(false);
                            // }, 3000);

                        }, (err) => {
                            setToasterType("error");
                            setHandleToaster(true)
                            setResMessage(err.data.message);
                            setLoaderActive(false)

                            setTimeout(() => {
                                setHandleToaster(false);
                            }, 11000);
                        }))
                    } else {
                        if (!emailValidation(companyEmail)) {
                            setIsEmailError(true);
                        }
                        if (!phoneValidation(phonenumber)) {
                            setIsPhoneError(true);
                        }
                    }
                }

                if (companyEmail.length === 0 && phonenumber.length === 0) {
                    // setIsPhoneError(true);
                    setIsEmailError(true);
                }
            }
        }

        // if (modalType == "add") {
        //     if (companyName.length > 2) {
        //         if (emailValidation(companyEmail)) {
        //             if (phoneValidation(phonenumber)) {
        //                 if (address != '') {
        //                     setLoaderActive(true)
        //                     const addCompany = new FormData();
        //                     addCompany.append("company_name_chr", companyName);
        //                     addCompany.append("company_phone_code_id_int", countryCode);
        //                     addCompany.append("company_phone_number_int", phonenumber);
        //                     addCompany.append("company_email_chr", companyEmail);
        //                     addCompany.append("place_id_chr", placeIdVal);
        //                     addCompany.append("address_line_1_chr", addressLine1);
        //                     addCompany.append("address_line_2_chr", addressLine2);
        //                     addCompany.append("city_name_chr", cityName);
        //                     addCompany.append("state_name_chr", stateName);
        //                     addCompany.append("country_name_chr", countryName);
        //                     addCompany.append("zip_code_int", zipCode);
        //                     addCompany.append("longitude_float", longVal);
        //                     addCompany.append("latitude_float", latVal);
        //                     addCompany.append("company_address_chr", address);
        //                     addCompany.append("user_id_ids", localStorage.getItem("user_id"));
        //                     photoToUpload != null && addCompany.append("company_logo", photoToUpload, "companyPhoto.png") 
        //                     dispatch(apiRegisterCompany(addCompany, (res) => {
        //                         setLoaderActive(false)
        //                         setToasterType("success");
        //                         setHandleToaster(true)
        //                         setResMessage(res.data.message);

        //                     }, (err) => {
        //                         setToasterType("error");
        //                         setHandleToaster(true)
        //                         setResMessage(err.data.message);
        //                     }))
        //                 } else {
        //                     setIsAddress(true)
        //                 }
        //             } else {
        //                 setIsPhoneError(true)
        //             }
        //         } else {
        //             setIsEmailError(true)
        //         }
        //     } else {
        //         setIsCompanyNameError(true)
        //     }

        // }



        if (modalType == "edit") {

            if (!firstNameValidation(firstName)) {
                setIsFirstNameError(true);
                if (firstName === "") {
                    setErrorFirstNameMsg(enterFirstName)
                } else {
                    setErrorFirstNameMsg(validFirstName)
                }
            }

            if (!minLengthValidation(companyName, 3)) {
                alert("Please enter valid company name")
                setIsCompanyNameError(true)
            }

            if (address == '') {
                setIsAddress(true)
            }
            if (companyEmail.length === 0 && phonenumber.length === 0) {
                // setIsPhoneError(true);
                setIsEmailError(true);
            }

            const einNumber = EIN?.replace(/\D/g, ""); // Remove the hyphen
            if (einNumber !== '') {
                if (einNumber.length !== 9) {
                    setEinErr(true)
                    return;
                }
            }

            if (firstNameValidation(firstName) && minLengthValidation(companyName, 3) && address != '') {
                if (address != '') {
                    setLoaderActive(true)
                    const editCompany = new FormData();
                    editCompany.append("company_id_ids", companyID);
                    editCompany.append("ein_chr", einNumber);
                    editCompany.append("company_name_chr", companyName);
                    editCompany.append("owner_first_name_chr", firstName);
                    editCompany.append("owner_last_name_chr", lastName);
                    editCompany.append("company_phone_code_id_int", countryCode || 0);
                    editCompany.append("company_phone_number_int", phonenumber || 0);
                    editCompany.append("company_email_chr", companyEmail);
                    editCompany.append("place_id_chr", placeIdVal);
                    editCompany.append("address_line_1_chr", addressLine1);
                    editCompany.append("address_line_2_chr", addressLine2);
                    editCompany.append("city_name_chr", cityName);
                    editCompany.append("state_name_chr", stateName);
                    editCompany.append("country_name_chr", countryName);
                    editCompany.append("zip_code_int", zipCode || 0);
                    editCompany.append("longitude_float", longVal || 0);
                    editCompany.append("latitude_float", latVal || 0);
                    editCompany.append("company_address_chr", address);
                    editCompany.append("user_id_ids", localStorage.getItem("user_id"));
                    photoToUpload != null && editCompany.append("company_logo", photoToUpload, "companyPhoto.png");
                    expertiseArray.length > 0 &&
                        expertiseArray.forEach((item, index) => {
                            editCompany.append("expertise_id_array", item);
                        })
                    dispatch(apiUpdateCompany(editCompany, (res) => {

                        setToasterType("success");
                        setResMessage(res.data.message);
                        handleClose();
                        setLoaderActive(false)

                        // setHandleToaster(true)
                        // setTimeout(() => {
                        //     setHandleToaster(false);
                        // }, 3000);

                    }, (err) => {
                        setLoaderActive(false)
                        setToasterType("error");
                        setHandleToaster(true)
                        setResMessage(err.data.message);
                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    }))
                } else {
                    setIsAddress(true)
                }
            }

        }

    }
    const profileImgRef = useRef();
    function handlePhotoSelected(e) {
        setPhotoToUpload(e.target.files[0])
        // console.log(e.target.files[0])
    }
    const handleClickProfileImg = () => {
        profileImgRef.current.click();
    }

    const popover = (
        <Popover id="popover-basic" className='custom-popover' style={{ minWidth: '60px', }}>

            {modalType != "view" && <Popover.Body style={{ padding: '5px', boxShadow: '0px 0px 15px 0px rgba(0, 0, 0, 0.2)', }} >
                <div className='d-flex ' >


                    <div style={{ cursor: 'pointer', margin: '1px', backgroundColor: 'white', }}>
                        <Button onClick={handleClickProfileImg} className='custom-profile-btn' variant='outline-primary'>
                            <i className="bi bi-plus"></i>
                        </Button>
                        <input ref={profileImgRef} onChange={handlePhotoSelected} type="file" accept="image/*" hidden />
                    </div>

                </div>

            </Popover.Body>}
        </Popover>
    );

    const handleFirstName = (e) => {
        setIsFirstNameError(false);
        setFirstName(e.target.value);
    };
    const handleLastName = (e) => {
        setLastName(e.target.value);
    };

    function handleFirstNameBlurCheck() {
        if (!firstNameValidation(firstName)) {
            setIsFirstNameError(true);
            if (firstName === "") {
                setErrorFirstNameMsg(enterFirstName)
            } else {
                setErrorFirstNameMsg(validFirstName)
            }
        }
    }

    // Add expertise functions 


    const [selectedOptions, setSelectedOptions] = useState([]);
    const [expertiseArray, setExpertiseArray] = useState([]);
    const [pageSizeCat, setPageSizeCat] = useState(25);
    const [pageCat, setPageCat] = useState(1);
    const [catOrder, setCatOrder] = useState("ASC")
    const [catArr, setCatArr] = useState([]);
    const [catId, setCatId] = useState();
    const [prodTypeArr, setProdTypeArr] = useState([]);

    useEffect(() => {
        if (modalType == "add" || modalType == "edit") {
            var forCatData = {
                page_index: pageCat,
                page_size: pageSizeCat,
                sorting_order: catOrder
            };

            dispatch(
                getCat(forCatData, (res) => {
                    setCatArr(res.data.data)
                }))
        }
    }, [pageCat, pageSizeCat, catOrder])


    const options = catArr?.map(category => ({
        value: category.category_id_ids,
        label: category.category_name_chr
    }));

    const handleChange = (selected) => {
        setSelectedOptions(selected || []);
    };

    useEffect(() => {
        setExpertiseArray(selectedOptions.map(option => option.value));
    }, [selectedOptions])


    const [switchRoleModal, setSwitchRoleModal] = useState(false);
    const handleOpenSwitchRoleModal = () => {
        setSwitchRoleModal(true);
        // setCompanyModalStatus(false);
    }

    const handleCloseSwitchRoleModal = () => {
        setSwitchRoleModal(false);
        setCompanyModalStatus(true);
    }



    const handleOpenShareCompanyCodeModal = () => {
        setShareCompanyCodeModalTrigger(true);
    }

    const handleCloseShareCompanyCodeModal = () => {
        setShareCompanyCodeModalTrigger(false);
        setCompanyModalStatus(true);

        setEmailPhoneValue("");
        setCodeValue();
        setIsEmailPhoneVal(false);
    }

    const handleShareCompanyCode = (e) => {
        e.preventDefault();
        if (phoneValidation(emailPhoneValue) || emailValidation(emailPhoneValue)) {
            setShareCompanyCodeLoading(true);
            if (isPhone) {
                const data = new FormData();
                data.append("company_id_ids", companyID)
                data.append("email_chr", "");
                data.append("phone_code_id_int", parseInt(codeValue) || 1);
                data.append("phone_number_int", emailPhoneValue);

                dispatch(
                    shareCompanyCodeApi(data, (res) => {
                        setShareCompanyCodeLoading(false)
                        setResMessage(res.data.message)
                        setToasterType("success")

                        handleCloseShareCompanyCodeModal();

                        // setHandleToaster(true);
                        // setTimeout(() => {
                        //     setHandleToaster(false);
                        // }, 4000);
                    }, (err) => {
                        setShareCompanyCodeLoading(false)
                        setResMessage(err.data.message)
                        setToasterType("error")

                        setHandleToaster(true);
                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    })
                );
            } else {

                const data = new FormData();
                data.append("company_id_ids", companyID)
                data.append("email_chr", emailPhoneValue);
                // data.append("phone_code_id_int", parseInt(codeValue) || 1);
                // data.append("phone_number_int", emailPhoneValue);

                dispatch(
                    shareCompanyCodeApi(data, (res) => {
                        setShareCompanyCodeLoading(false)
                        setResMessage(res.data.message)
                        setToasterType("success")

                        handleCloseShareCompanyCodeModal();

                        // setHandleToaster(true);
                        // setTimeout(() => {
                        //     setHandleToaster(false);
                        // }, 11000);
                    }, (err) => {
                        setShareCompanyCodeLoading(false)
                        setResMessage(err.data.message)
                        setToasterType("error")

                        setHandleToaster(true);
                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    })
                );
            }
        } else {
            setIsEmailPhoneVal(true);
        }
    };

    const handleEmailPhone = (e) => {
        setIsEmailPhoneVal(false);

        noSpaceOnChange(e.target.value) && setEmailPhoneValue(e.target.value);
    };
    const handleDropdownValue = (e) => {
        // setCodeValue(e.target.value);
        setCodeValue(e);
    };

    useEffect(() => {
        const dot = ".";
        const leng = emailPhoneValue.length - 1;
        if (!isNaN(emailPhoneValue) && emailPhoneValue.charAt(leng) !== dot) {
            if (emailPhoneValue.length < 11) {
                setIsPhone(true);
            } else {
                setIsPhone(false);
            }
        } else {
            setIsPhone(false);
        }
        if (emailPhoneValue === "") {
            setIsPhone(false);
        }
    }, [emailPhoneValue]);

    function handleEmailPhoneBlur() {
        if (isPhone) {
            if (!phoneValidation(emailPhoneValue)) {
                setIsEmailPhoneVal(true);
            }
        } else {
            if (!emailValidation(emailPhoneValue)) {
                setIsEmailPhoneVal(true);
            }
        }
    }

    return (
        <>
            <div>

                {!shareCompanyCodeModalTrigger ?
                    <>
                        {/* <!-- Modal --> */}
                        {!switchRoleModal &&
                            <Modal className="fade" size={"md"} show={companyModalStatus}
                                // onHide={handleClose}
                                centered
                            >
                                {/* <Modal.Header style={{ borderBottom: 'none' }}>
                    <Modal.Title>
                        {modalType == "view" && "Company Details"}
                        {modalType == "edit" && "Edit Company Details"}
                        {modalType == "add" && "Add Company Details"}

                    </Modal.Title>
                    <Button
                        variant=""
                        className="call-btn-close btn-close"
                        onClick={handleClose}
                    >

                    </Button>
                </Modal.Header> */}


                                <Modal.Body>

                                    <div className='mx-0 row text-black mb-4'>
                                        <div className='col-12 d-flex fs-4 justify-content-end px-0'>
                                            <span onClick={() => handleClose()} className='cursor-pointer'>
                                                <i className="bi bi-x-lg"></i>
                                            </span>
                                        </div>

                                        <div className='col-12 font-w600 fs-3 px-0 text-center'>
                                            <span>
                                                {modalType == "edit" && "Edit company details"}
                                                {modalType == "add" && "Add company details"}
                                                {modalType == "view" && "Company details"}
                                            </span>
                                        </div>
                                    </div>

                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            marginBottom: '20px',
                                            pointerEvents: modalType == "view" ? 'none' : 'auto',
                                        }}
                                    >
                                        {/* <OverlayTrigger trigger='click' placement="bottom" overlay={popover} rootClose={true} > */}
                                        <div className='image-group' onClick={handleClickProfileImg} style={{ width: '10%' }} >
                                            {/* <Avatar src={profileAv} size="60" alt="" /> */}
                                            <Avatar src={photoToUpload != null ? URL.createObjectURL(photoToUpload) : companyAvatarUrl} size="55" alt="" />
                                            {(modalType !== "view") && <img className='edit-profile-icon' src={filter} alt="" />}
                                            <input ref={profileImgRef} onChange={handlePhotoSelected} type="file" accept="image/*" hidden />
                                        </div>
                                        {/* </OverlayTrigger> */}
                                    </div>

                                    {/* Switch Role for company admin */}
                                    {/* {roleArr?.length > 1 &&
                                        <div className='row my-2'>
                                            <div className='col-12 px-0 d-flex justify-content-end align-items-center'>
                                                <div
                                                    className='fs-5 p-2 cursor-pointer overlay-action-btn rounded-1 font-w600 text-black d-flex align-items-center border border-light shadow-sm px-3'
                                                    onClick={handleOpenSwitchRoleModal}
                                                >
                                                    <PiUserSwitchBold
                                                        style={{ fontSize: "18px" }}
                                                        className="bi bi-lock text-primary"
                                                    />
                                                    <span className="ms-3">{"Switch Role"}</span>
                                                </div>
                                            </div>
                                        </div>
                                    } */}

                                    <div style={{}}>
                                        <p style={{ fontSize: '14px', fontWeight: '600', color: 'black', marginBottom: '0px' }}>{"Owner Details"}</p>
                                        <div className='mt-2' style={{ borderRadius: '5px', }}>
                                            <div className='combine-input-fileds'
                                                style={{
                                                    pointerEvents: modalType == "view" ? 'none' : 'auto',
                                                }}
                                            >
                                                <div className='comapany-address' style={{ width: '49%' }}>
                                                    <InputField
                                                        labelName={lblFirstName}
                                                        placeholderName={lblFirstName}
                                                        value={firstName}
                                                        onChange={(e) => (modalType !== "view") && handleFirstName(e)}
                                                        errorOccured={isFirstNameError}
                                                        errorMeesage={errorFirstNameMsg}
                                                        onBlur={handleFirstNameBlurCheck}
                                                        isRequired={true}
                                                    />
                                                </div>

                                                <div className='comapany-address' style={{ width: '49%' }}>
                                                    <InputField
                                                        labelName={lblLastName}
                                                        placeholderName={lblLastName}
                                                        value={lastName}
                                                        onChange={(e) => (modalType !== "view") && handleLastName(e)}
                                                        errorOccured={false}
                                                        errorMeesage={""}
                                                        onBlur={() => { }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <p style={{ fontSize: '14px', fontWeight: '600', color: 'black', marginBottom: '0px' }}>{"Business Details"}</p>
                                        <div className='mt-2'
                                            style={{
                                                borderRadius: '5px',
                                                padding: '5px 0px',
                                                pointerEvents: modalType == "view" ? 'none' : 'auto',
                                            }}
                                        >

                                            <InputField
                                                labelName={"Business name"}
                                                placeholderName={"Business name"}
                                                onChange={(e) => (modalType !== "view") && handleCompanyName(e)}
                                                onBlur={handleCompanyNameBlurCheck}
                                                errorOccured={isCompanytNameError}
                                                errorMeesage={"invalid company name"}
                                                value={companyName}
                                                isRequired={true}
                                            />

                                            <InputField
                                                labelName={"EIN"}
                                                placeholderName={"EIN"}
                                                onChange={handleEIN}
                                                onBlur={() => { handleOnBlurEIN() }}
                                                errorOccured={einErr}
                                                errorMeesage={"Please enter valid EIN"}
                                                value={EIN}
                                                maxLength={10}
                                            />


                                            {/* <InputField
                                labelName={"Email"}
                                placeholderName={"Email"}
                                onChange={handleCompanyEmail}
                                onBlur={handleCompanyEmailBlurCheck}
                                errorOccured={isEmailError}
                                errorMeesage={validEmail_OR_MobileNumberText}
                                value={companyEmail}
                            /> */}

                                            {/* <PhonenumberField
                                inputValue={phonenumber}
                                handleInputValue={handlePhonenumber}
                                errorOccured={isPhoneError}
                                errorMeesage={validMobileNumberText}
                                handleChangeCode={handleCountryCode}
                                handleOnBlur={handlePhonenumberBlurCheck}
                            /> */}

                                            {(modalType == "view") &&
                                                <>
                                                    <div className='row'>
                                                        <div className='col-12 d-flex fs-6 mb-2'>
                                                            <div>
                                                                <span className='fw-bold'>{`Expertise `}</span>
                                                            </div>
                                                            <div className='ms-2'>
                                                                {expertiseArr.length > 0 ?
                                                                    <>
                                                                        {expertiseArr.map((item, index) => {
                                                                            return <span key={index}>{`${item?.expertise_name_chr}, `}</span>
                                                                        })}
                                                                    </> :
                                                                    <span>{`No expertise added`}</span>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            }

                                            {/* Here is multiselect expertise */}
                                            {(modalType == "add" || modalType == "edit") &&
                                                <div>
                                                    <label className="mb-1"><strong>{"Add Expertise"}</strong></label>
                                                    <Select
                                                        isMulti
                                                        value={selectedOptions}
                                                        onChange={handleChange}
                                                        options={options}
                                                        placeholder="Add Expertise..."
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                        styles={{
                                                            control: (provided) => ({
                                                                ...provided,
                                                                borderColor: 'rgba(107, 107, 107, 0.12)',
                                                                borderWidth: 2,
                                                                borderRadius: '7px',
                                                                padding: '2px 0px !important',
                                                                marginBottom: '10px',
                                                                boxShadow: 'none',
                                                                '&:hover': {
                                                                    borderColor: 'rgba(107, 107, 107, 0.12)',
                                                                },
                                                            })
                                                        }}
                                                    />
                                                </div>}


                                            <label className="mb-1"><strong>{"Address *"}</strong></label>
                                            <Select
                                                isSearchable
                                                name="color"
                                                placeholder={address ? address : txtSearchAddress}
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        borderColor: isAddress ? 'red' : 'rgba(107, 107, 107, 0.12)',
                                                        borderWidth: 1,
                                                        borderRadius: '7px',
                                                        padding: '2px 0px !important',
                                                        marginBottom: '5px',
                                                        boxShadow: 'none',
                                                        '&:hover': {
                                                            borderColor: 'rgba(107, 107, 107, 0.12)',
                                                        },
                                                    }),
                                                    pointerEvents: modalType == "view" ? 'none' : 'auto',
                                                }}
                                                options={addressArr}
                                                getOptionLabel={(option) => option.description}
                                                getOptionValue={(option) => option.description}
                                                onInputChange={setSearchText}
                                                onChange={option => {
                                                    setIsAddress(false)
                                                    setPlaceId(option.place_id)
                                                    let details = {
                                                        place_id: option.place_id
                                                    }
                                                    dispatch(addressByPlaceId(details, (res) => {
                                                        setSearchText('')
                                                        setStateName(res.data.data.complete_address.state_name_chr)
                                                        setZipCode(res.data.data.complete_address.zip_code_int)
                                                        setCityName(res.data.data.complete_address.city_name_chr)
                                                        setCountryName(res.data.data.complete_address.country_name_chr)
                                                        setLongVal(res.data.data.location.lng)
                                                        setLatVal(res.data.data.location.lat)
                                                        setAddress(res.data.data.formatted_address)
                                                        setAddressLine1(res.data.data.complete_address.address_line_1_chr)
                                                        setAddressLine2(res.data.data.complete_address.address_line_2_chr)
                                                    }))
                                                }}
                                            />

                                            {isAddress && <div className="text-danger fs-12" style={{ height: "16px" }}>{"Enter company Address"}</div>}


                                        </div>

                                        {companyID &&
                                            <>
                                                <div className='row mx-0 mb-3'>
                                                    <div className='col-md-6 pe-md-2 mb-2'>
                                                        <div className='fs-5'>
                                                            <span className='me-3'>
                                                                <div className="tooltipCustom ">
                                                                    <span className="tooltiptextCustom w-100" style={{ minWidth: '100px' }}>{"You can share your company code with Professionals to add them in your company"}</span>
                                                                    <span
                                                                        className={`cursor-pointer text-hovered`}
                                                                    >
                                                                        <i className='bi bi-info-circle'></i>
                                                                    </span>
                                                                </div>
                                                            </span>

                                                            <span className='me-2'>{"Company code : "}</span>
                                                            <span className='font-w600 text-black me-2'>{companyCode}</span>

                                                            <div className="tooltipCustom ">
                                                                <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Copy to clipboard"}</span>
                                                                <span
                                                                    onClick={() => { copyToClipboard() }}
                                                                    className={`cursor-pointer text-hovered`}
                                                                >
                                                                    <MdContentCopy />
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='col-md-6 ps-md-2 mb-2 d-flex'>
                                                        <div className='d-flex'>
                                                            <div
                                                                className='fs-5 font-w600 cursor-pointer text-hovered d-flex align-items-center'
                                                                onClick={() => { handleOpenShareCompanyCodeModal() }}
                                                            >
                                                                <span className='me-3'>
                                                                    <i className='bi bi-share'></i>
                                                                </span>

                                                                <span className='me-2'>{`Share code`}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div>




                                    {modalType != "view" &&
                                        <div className="d-flex align-items-center justify-content-end">
                                            <PrimaryButton
                                                onClick={handleSubmit}
                                                buttonName={modalType == "add" ? "ADD COMPANY" : " EDIT DETAILS"}
                                                isLoading={loaderActive}
                                                loadingMessage={modalType == "add" ? "ADDING" : "UPDATING"}
                                                style={{
                                                    width: '100%',
                                                    border: 'none',
                                                    background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                                    boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                                }}
                                            />
                                        </div>
                                    }


                                </Modal.Body>

                            </Modal >
                        }

                        {switchRoleModal &&
                            <SwitchRole
                                // changeDefaultRole={(e, n) => {
                                //   setChangedRoleId(e);
                                //   setRoleName(n);
                                // }}
                                modalStatus={switchRoleModal}
                                onClose={handleCloseSwitchRoleModal}
                                rolesArray={roleArr}
                                defaultRoleId={role}
                                defaultUserRoleName={roleDisplayName}
                            />
                        }
                    </> :
                    <>
                        {/* Share Service request modal */}
                        <>
                            {/* <!-- Modal --> */}
                            <Modal className="fade" show={shareCompanyCodeModalTrigger}
                                // onHide={handleClose} 
                                centered
                            >
                                <Modal.Body>
                                    <>
                                        <div className='row mx-0'>
                                            <div className='col-12 px-0'>

                                                <div className='row mx-0'>
                                                    <div className='col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black'>
                                                        <span onClick={() => handleCloseShareCompanyCodeModal()} className='cursor-pointer'>
                                                            <i className="bi bi-x-lg"></i>
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className='row mx-0'>
                                                    <div className='fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black'>
                                                        <span className=''>
                                                            {"Share company code"}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className='row mx-0 my-4'>
                                                    <div className='font-w500 col-12 px-0 d-flex align-items-center justify-content-center fs-5 '>
                                                        <span className=' text-center'>
                                                            {"Enter an email or phone number to share the company code."}
                                                        </span>
                                                    </div>
                                                </div>

                                                <form className='w-100' onSubmit={(e) => handleShareCompanyCode(e)}>
                                                    <EmailPhoneCombine
                                                        inputValue={emailPhoneValue}
                                                        handleChangeCode={handleDropdownValue}
                                                        handleInputValue={handleEmailPhone}
                                                        isEnteringNumber={isPhone}
                                                        setIsEnteringNumber={setIsPhone}
                                                        errorOccured={isEmailPhoneVal}
                                                        errorMessage={validEmail_OR_MobileNumberText}
                                                        handleOnBlur={handleEmailPhoneBlur}
                                                        defaultCodeValue={codeValue}
                                                        isRequired={true}
                                                    />

                                                    <div className='row mx-0 mt-1'>
                                                        <div className='font-w500 col-12 px-0 d-flex align-items-center justify-content-center fs-5 '>
                                                            <PrimaryButton
                                                                buttonName={"SHARE CODE"}
                                                                onClick={(e) => handleShareCompanyCode(e)}
                                                                loadingMessage={"LOADING..."}
                                                                isLoading={shareCompanyCodeLoading}
                                                                style={{
                                                                    width: '100%',
                                                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                    border: '2px solid rgba(255, 154, 32, 1)',
                                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                    fontWeight: '600'
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </form>

                                            </div>
                                        </div>
                                    </>
                                </Modal.Body>
                            </Modal>
                        </>
                    </>
                }



                {handleToaster && (
                    <ResponceToaster toasterType={toasterType} message={resMessage} />
                )}
            </div>
        </>
    )
}

export default UserAddOwnCompany;